import Vue from 'vue'
// 弹窗组件单文件
import Message from './index.vue'

const createMessage = (options = {text: '提示信息', timeout: 2000}) => {

  const vm =  new Vue({
    render: (h) => {
      return h(
        Message,
        {
          props: {
            text: options.text
          }
        }
      )
    }
  }).$mount()

  document.body.appendChild(vm.$el)

  setTimeout(() => {
    document.body.removeChild(vm.$el);
  }, options.timeout || 2000)

}

export default createMessage;